// import "../styles/MainPage.scss";
import { FaGoogle, FaGithub } from "react-icons/fa";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { CgMore } from "react-icons/cg";
import { FiEye, FiEyeOff } from "react-icons/fi";

import logo from "../assets/0_nobg.png"
import CLink from "../components/CLink";


import { useEffect, useState, useRef } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useMisc } from "../contexts/MiscContext";
import axios from "../scripts/axiosConfig";

import "../styles/Login.scss";

import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";


export default function Login() {

    const { SIGN_IN_WITH_EMAIL, signinwithpopup, currentUser, setCurrentUser, setUserJson } = useAuth();
    const { readableError } = useMisc();

    const [oauthUsername, setOauthUsername] = useState("");
    const usernameInputRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);
    const pwdToggler = useRef<HTMLSpanElement>(null);
    const signInBtn = useRef<HTMLButtonElement>(null);

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [signInProcessing, setSignInProcessing] = useState(false);
    const [showUsernameModal, setShowUsernameModal] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    const handleSignIn = async () => {
        setSignInProcessing(true);

        const email = usernameInputRef.current?.value;
        const password = passwordRef.current?.value;

        if (!email || !password) {
            setSignInProcessing(false);
            return;
        }

        SIGN_IN_WITH_EMAIL(email, password)
        .then(async (authRes: any) => {
            console.log(authRes);

            axios.post("/users/login_email", {
                uid: authRes.user.uid,
                email: authRes.user.email,
            },
            {
                headers: { "Authorization": `Bearer ${await authRes.user.getIdToken()}` }
            }
            )
            .then((dbRes: any) => {
                console.log(dbRes);
                setUserJson(dbRes.data.user);
                setSignInProcessing(false);
                if (location.state?.from === "/signup") {
                    navigate("/explore")
                }
                else {
                    navigate(location.state?.from);
                }
            })
            .catch((err) => {
                setSignInProcessing(false);
                console.error(err);
                setUserJson({});
                toast.error((err.response.data.message) ? `${err.response.data.error} - ${err.response.data.message}` : (err.response.data.error)  || err.code);
            });
        })
        .catch((err: any) => {
            console.error(err);
            setUserJson({});
            toast.error(readableError(err.code));
            setSignInProcessing(false);
        })
    }

    const handleSignInWithProviders = ( provider: "GOOGLE" | "GITHUB" ) => {
        setSignInProcessing(true);

        signinwithpopup(provider)
        .then(async (authRes: any) => {
            console.log(authRes);

            axios.post("/users/login_provider", {
                mode: provider,
                uid: authRes.user.uid,
                email: authRes.user.email,
                profileImageURL: authRes.user.photoURL,
                displayName: authRes.user.displayName,
                // username: oauthUsername,
            },
            {
                headers: { "Authorization": `Bearer ${await authRes.user.getIdToken()}` }
            })
            .then((res: any) => {
                console.log(res);
                setSignInProcessing(false);
                if (res.data.code == "AUTO_GEN_UNAME_DNAME") {
                    toast.info("Your account has been created with autogenerated username. Please change it.")
                }
                if (res.data.user) {
                    setUserJson(res.data.user);
                }
                if (location.state?.from === "/signup") {
                    navigate("/explore")
                }
                else {
                    navigate(location.state?.from);
                }
            })
            .catch((err) => {
                setSignInProcessing(false);
                console.error(err);
                toast.error( readableError(err.response.data.error) || readableError(err.message) );
                if (err.response.data.code === "GET_USERNAME_DNAME") {
                    setShowUsernameModal(true);
                    // navigate("/signup", { state: { from: location.state?.from } });
                }
            });
        })
        .catch((err: any) => {
            console.error(err);
            setSignInProcessing(false);
            toast.error(readableError(err.code));
        });
    
    }

    const completeOauthSignUp = () => {
        console.log("Completing oauth signup.");
        setSignInProcessing(true);

        axios.post(
            "/users/signup_provider",
            {
                mode: "X-GOOGLE",
                uid: currentUser.uid,
                email: currentUser.email,
                profileImageURL: currentUser.photoURL,
                displayName: currentUser.displayName,
                // username: oauthUsername,
                username: "test-oauth-username"
            }
        )
        .then((res: any) => {
            console.log(res);
            setSignInProcessing(false);
            setUserJson(res.data.user);

            if (location.state?.from === "/signup") {
                navigate("/explore")
            }
            else {
                navigate(location.state?.from);
            }
        })
        .catch((err) => {
            setSignInProcessing(false);
            console.error(err);
            toast.error(err.response.data.error || err.message);
            // if (err.response.data.code === "GET_USERNAME_DNAME") {
            //     setShowUsernameModal(true);
            //     // navigate("/signup", { state: { from: location.state?.from } });
            // }
        });
    }

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const email = urlParams.get('email');

        console.log("Starting up login page.");
        console.log("User is from",  location.state?.from);


        if (email) {
            usernameInputRef.current!.value = email;
            passwordRef.current!.focus();
        }
    }, []);

    return (
        <section className="loginSection">

            {
                (showUsernameModal) && (
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        setOauthUsername("test");
                        // handleSignInWithProviders("GOOGLE");
                        completeOauthSignUp();
                    }} 
                    className="usernameModal">
                        MODAL TO ASK FOR USERNAME AND DNAME

                        <input 
                            type="text" 
                            placeholder="Enter your username" 
                            defaultValue={currentUser?.displayName} 
                        />
                        <input 
                            type="text" 
                            placeholder="Enter your display name" 
                        />

                        <button>
                            Continue
                        </button>
                    </form>
                )
            }

            <div className="topNavSpace">
                <CLink to="/">
                    <img src={logo} alt="c0dify logo" />
                </CLink>
            </div>

            <div className="loginBox">
                <div className="top-bar">
                <div className="numbers">
                    <div className="numbers-slide">
                        <span className="firstBin">0</span>
                        <span>1</span>
                        <span>1</span>
                        <span>0</span>
                        <span>1</span>
                        <span>0</span>
                        <span>0</span>
                        <span>0</span>
                        
                        <span className="firstBin">0</span>
                        <span>1</span>
                        <span>1</span>
                        <span>0</span>
                        <span>1</span>
                        <span>0</span>
                        <span>0</span>
                        <span>1</span>
                        <span>!</span>
                    </div>

                    <div className="numbers-slide">
                    <span className="firstBin">0</span>
                        <span>1</span>
                        <span>1</span>
                        <span>0</span>
                        <span>1</span>
                        <span>0</span>
                        <span>0</span>
                        <span>0</span>
                        
                        <span className="firstBin">0</span>
                        <span>1</span>
                        <span>1</span>
                        <span>0</span>
                        <span>1</span>
                        <span>0</span>
                        <span>0</span>
                        <span>1</span>
                        <span>!</span>
                    </div>
                </div>
                </div>

                <div className="welcomeText">
                    {/* <span className="top">Welcome to <span className="c0difyText">c0dify!</span></span> */}
                    <span className="top">Welcome back!</span>
                    <span className="bottom"><span className="signIn">Sign In</span> to c0dify.</span>
                </div>

                <div className="inputContainer">
                    <div className="username-container">
                        <span className="username-text">Email</span>
                        <input
                            name="usernameOrEmail"
                            type="text"
                            autoCapitalize="none"
                            className="username-text"
                            ref={usernameInputRef}
                        />
                    </div>
                    <div className="password-container">
                        <span className="password-text">Password</span>
                        <div className="pwdContainer">
                            <input
                                name="password"
                                type={passwordVisible ? "text" : "password"}
                                className="password-text"
                                autoCapitalize="none"
                                ref={passwordRef}
                            />
                            <span
                                className="showButton"
                                onClick={() =>  setPasswordVisible(!passwordVisible) }
                                ref={pwdToggler}
                            >
                                {passwordVisible ? (
                                    <FiEyeOff size={"15px"} />
                                ) : (
                                    <FiEye size={"15px"} />
                                )}
                            </span>
                            <CLink 
                                className="forgotPasswordLink" 
                                to={ (usernameInputRef.current?.value) ? `/forgot-password?email=${usernameInputRef.current?.value}` : '/forgot-password' }
                            >
                                Forgot password?
                            </CLink>
                        </div>

                    </div>
                </div>

                <div className="buttonContainer">
                    <button
                        className={("sign-in-btn" + (signInProcessing ? " loading" : "") )}
                        ref={signInBtn}
                        disabled={signInProcessing}
                        onClick={!signInProcessing ? handleSignIn : undefined}
                    >
                            <AiOutlineLoading3Quarters className="pasteLoader" />
                            <span>
                                { signInProcessing ? "Signing in..." : "Sign In" }
                            </span>
                    </button>
                </div>

                <div className="splitter">
                    <div className="splitLine"></div>
                    <span className="or">or</span>
                    <div className="splitLine"></div>
                </div>

                <div className="moreWays">
                        <span className="circle provider" onClick={() => handleSignInWithProviders("GOOGLE")}>
                            <FaGoogle size={"15px"} />
                        </span>
                        <span className="circle provider" onClick={() => handleSignInWithProviders("GITHUB")}>
                            <FaGithub size={"15px"} />
                        </span>
                        <span className="circle moreProviders" onClick={() => toast.info("Coming Soon!")} >
                            <CgMore size={"15px"}/>
                        </span>
                </div>

                <div className="goToSignup">
                    <CLink to="/signup">
                        Don't have an account?
                    </CLink>
                </div>
                
            </div>

        </section>
    );
}